import { render } from "./dynamic-tasks-row.vue?vue&type=template&id=7afe0e1d"
import script from "./dynamic-tasks-row.vue?vue&type=script&lang=js"
export * from "./dynamic-tasks-row.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTd,QBtn,QSlideTransition,QDialog,QCard});
